// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__YW5Y0","description":"MealItem_description__S8ICc","price":"MealItem_price__kSqLG"};